import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { VesselScheduleComponent } from './vessel-schedule/vessel-schedule.component';
const routes: Routes = [
  {
    path: "",
    component: VesselScheduleComponent,
  },
  {
    path: ":origin/:destination",
    component: VesselScheduleComponent,
  },
  {
    path: 'vessel-schedule/:origin/:destination',
    component: VesselScheduleComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class VesselScheduleRoutingModule { }
